<template>
  <div class="container">
    <heard :title="'语言评估'" ref="heard" />
    <div class="content">
      <div class="leftImg">
        <!-- <img src="https://language.phenxie.com/oss/logo.svg" alt="" /> -->
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;老年多模态多媒体语料库(Multimodal-Multimedia Corpora of Gerontic Discourse, MMCGD) 为针对60岁及以上老年人的专门人群语料库。修饰语“多模态”指语料库采样内容包含老年人调用多模态感官系统与内外部环境进行互动。采录这样的多模态互动信息需要多种信号采集手段。修饰语“多媒体”正是用来统指多种信号采集手段。传统中医常用的方法是望闻问切，即医生利用自身的多模态感官系统与求诊者互动，从而获取求诊者的证候信息。当今数字采录技术为研究者提供了类似望闻问切的手段，如进入人们日常生活的数字录音（类似问）和数字录像（类似望），特别是智能手机，通过音视频采录技术为研究者提供老人的语音信息和体貌信息。本语料库英文名称里corpora 是复数，这补充汉语“语料库”不分单复数的缺陷，MMCGD 实际上含有多个子库。另外，“多模态”和“多媒体”并用，拟传达一个特殊的用意。多模态统指人类感官系统，多媒体统指多种信号采集技术，后者是用来采集前者行为所发出的信号，两者显然是不同性质的东西。然而文献里把两者混为一谈的是屡见不鲜，造成不必要的混乱。
          </p>
            <p>
            &nbsp;&nbsp;&nbsp;&nbsp;
  MMCGD萌发于现代汉语现场即席话语多模态语料库(Spoken Chinese Corpora of Situated Discourse, SCCSD)。 SCCSD始建于1990年初。MMCGD在当时是作为特殊人群话语类（special discourse genre）的一个样本。MMCGD在国家社科基金重点项目--- 基于老年多模态语料库老年语言能力与语言障碍研究 --- 驱动下独立建库。项目书里“老年多模态语料库”的英文译名为 Multimodal Corpus for Aging Studies (MCAS)。现在为了突出话语这个焦点，改用现在这个译名。
    </p>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
  MMCGD这类语料库放在世界语料库发展史上看还处于初始阶段。语料库（corpus）作为语言材料仓库，其建设可以追溯到早期词典和大百科编撰。编写者要准备大量的词条卡片以及插入标签的书籍。如Oxford English Dictionary的词条卡片，《现代汉语词典》也有大量的纸质卡片。英国语言学家Randoff Quirk主持、1959年启动的英语惯用法调查，起初都是做纸质卡片，直到1975年Svartvik 在伦德大学才着手把其中的口语库纸质记录转成计算机可读，即著名的London-Lund Corpus (LLC)。计算机及其数字化技术给语料库建设带来无与伦比的变更。语料库语言学前驱Geoffrey N. Leech 于1976年在兰开斯特大学始建LOB Corpus，经费很少，困难到用自己工资支付助手费用。暂且以此为机读语料库为标杆，经过50多年的发展，如今各种类型的语料库举不胜举。随着全球人口老龄化日趋加快，许多发达国家把解决老龄化提升到国家发展战略问题这个高度。我国相比之下是“未富先老”，挑战更大。研发老年多模态多媒体语料库已经成为刚需，小规模的专门用途的语料库相继出现。
    </p>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
  作为专门人群语料库，MMCGD 一方面遵循语料库语言学的基本原理与规则，另一方面突出自身的特点。
  </p>
        </p>
      </div>
      <div class="rightCont">
        <div class="title">
          欢迎来到<span>老年多模态多媒体语料库切分标注平台</span>
        </div>
        <div class="choose">可选择以下语料采集量表</div>
        <!-- <div class="btn" @click="goMMSE">MMSE检测</div> -->
        <el-select style="width: 250px;"
          @change="selectPage"
          v-model="pageValue"
          placeholder="请选择测试试卷"
        >
          <el-option
            v-for="item in pageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="one commwrap"> -->
      <!-- <div class="mmme commcontent" @click="goMMMe">MMSE检测</div> -->
      <!-- </div> -->
      <!-- <div class="two commwrap"> -->
      <!-- <div class="moca commcontent" @click="goMoCA">MoCA检测</div> -->

      <!-- <div class="fer commcontent">面部表情识别</div> -->
      <!-- </div> -->
      <!-- <div class="three commwrap"> -->
      <!-- </div> -->
      <!-- <div class="four commwrap"> -->
      <!-- <div class="frmr commcontent">人体姿态识别</div> -->
      <!-- </div> -->
    </div>

    <el-dialog
      title="平台语料采集授权协议书"
      :visible.sync="showAggrementFlag"
      width="1000px"
      :before-close="handleClose"
      v-if="showAggrementFlag"
    >
      <div class="dialogBody">
        <div class="content1">授权书相关文档</div>
        <div class="content2">
          <div class="left">
            <div class="radio">
              <el-radio v-model="radio" label="1"></el-radio>
            </div>
            <div class="title-b">
              请在以下矩形区域内手写签名，完成需点击确定并上传
            </div>
            <div class="canvas">
              <sign-canvas
                class="sign-canvas"
                ref="SignCanvas"
                :options="options"
                v-model="canvasValue"
              />
              <div class="btnList" ref="btnList">
                <el-button type="danger"  size="small" @click="clearSignImg">清空</el-button>
                <!-- <el-button type="primary" size="small"  @click="saveSignImg">保存</el-button> -->
              </div>

            </div>
          </div>
          <div class="right">
            <div class="radio">
              <el-radio v-model="radio" label="2"></el-radio>
            </div>
            <el-upload
              class="upload"
              action
              :on-change="handleChange"
              :auto-upload="false"
            >
              <el-button type="primary" :size="'small'"
                >上传授权书图片</el-button
              >
            </el-upload>
            <el-link type="primary" @click="downLoadTemplate">下载模板</el-link>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button small="mini" @click="showAggrementFlag = false"
          >取 消</el-button
        >
        <el-button small="mini" type="primary" @click="comfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <foot />
  </div>
</template>

<script>
import { mapState } from "vuex";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import SignCanvas from "sign-canvas";
import {
  uploadImage,
  queryExists,
  getListbox,
  addAuthorize,
} from "@/utils/custom.js";
export default {
  name: "VueMmse",
  data() {
    return {
      showAggrementFlag: false,
      dialogIndex: 1,
      radio: "1",
      auImageUrl: "",
      pageList: [],
      pageValue: "",
      currentMmseId: "",
      canvasValue:null,
      options: {
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: "917", //canvas宽高 [Number] 可选
        canvasHeight: "200", //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: "#E6E6E6", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#ff787f", //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
      testPageTitle:''
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch:{
    userInfo:{
      handler(v){
        if(v.userId){
          this.pageValue = ''
          this.getSelectListFn()
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    getSelectListFn(){
      const params = {
      userId: this.userInfo.userId,
    };
    this.pageList = []
    getListbox(params).then((res) => {
      if (res.data) {
        const keyArray = Object.keys(res.data);
        keyArray.forEach((item) => {
          this.pageList.push({
            label: res.data[item],
            value: item,
          });
        });
      }
    });
    },
    downLoadTemplate() {
      window.open(
        "https://language.phenxie.com/oss/%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E7%89%88.docx"
      );
    },
    // saveSignImg(){
    //   const file = this.$refs.SignCanvas.saveAsImg()
    // },
    clearSignImg() {
      this.$refs.SignCanvas.canvasClear();
    },
    comfirm() {
      if (this.radio == 2 && !this.auImageUrl) {
        this.$message.warning("请先上传图片");
        return;
      }
      if (this.radio == 1 && !this.canvasValue) {
        this.$message.warning("请先签名");
        return;
      }
      if(this.radio == 1 && this.canvasValue){
        // canvas 先手动上传
          let fd = new FormData();
          fd.append("file", this.base64ToFile(this.$refs.SignCanvas.saveAsImg(),'手写签名'));
          fd.append("userId", this.userInfo.userId);
          uploadImage(fd).then((res) => {
            this.auImageUrl = res.msg;
            this.sendSubmit()
          });
          return
      }
      this.sendSubmit()
    },
    sendSubmit(){
      if(!this.userInfo.userId){
        this.$message.warning('请先登录')
        return
      }
      const params = {
        userId: this.userInfo.userId,
        mmseId: this.currentMmseId,
        auType: this.radio == 1 ? "手写签名" : "上传图片",
        auTypeEnum: this.radio * 1,
        auImageUrl: this.auImageUrl,
      };
      addAuthorize(params).then((res) => {
        this.auImageUrl = "";
        this.showAggrementFlag = false;
        this.$router.push({
          name:'testPage',
          query:{
            id:this.currentMmseId,
            opeartType:'add',
            testPageTitle:this.testPageTitle,
            authinfoId:res.data.authinfoId
          }
        })
      });
    },
    handleClose() {
      this.showAggrementFlag = false;
    },
    selectPage(key) {
      if(!this.userInfo.userId){
        this.$message.warning('请先登录')
        return
      }
      this.testPageTitle = this.pageList.filter(item=>item.value == key)[0].label;
      this.currentMmseId = key;
      this.showAggrementFlag = true;
      // const params = {
      //   userId: this.userInfo.userId,
      //   mmseId: key,
      // };
      // queryExists(params).then((res) => {
      //   if (!res.data) {
      //     this.currentMmseId = key;
      //     this.showAggrementFlag = true;
      //   }else{
      //     this.$router.push({
      //       name:'testPage',
      //       query:{
      //         id:key,
      //         opeartType:'add',
      //         testPageTitle:this.testPageTitle
      //       }
      //     })
      //   }
      // });
    },
     base64ToFile(base64, fileName) {
      // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
      let data = base64.split(',');
      // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
      let type = data[0].match(/:(.*?);/)[1];
      // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
      let suffix = type.split('/')[1];
      // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
      const bstr = window.atob(data[1]);
      // 获取解码结果字符串的长度
      let n = bstr.length
      // 根据解码结果字符串的长度创建一个等长的整形数字数组
      // 但在创建时 所有元素初始值都为 0
      const u8arr = new Uint8Array(n)
      // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
      while (n--) {
        // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
        u8arr[n] = bstr.charCodeAt(n)
      }
      // 利用构造函数创建File文件对象
      // new File(bits, name, options)
      const file =  new File([u8arr], `${fileName}.${suffix}`, {
        type: type
      })
      // 将File文件对象返回给方法的调用者
      return file;
    },
    handleChange(file) {
      this.file = file.raw;
      let fd = new FormData();
      fd.append("file", this.file);
      fd.append("userId", this.userInfo.userId);
      uploadImage(fd).then((res) => {
        this.auImageUrl = res.msg;
        this.$message.success("上传成功");
      });
    },
    goMMSE() {
      if (!this.userInfo.userName) {
        this.$refs.heard.loginVisible = true;
        return;
      }
      this.$router.push("./mmse");
    },
    goMoCA() {
      this.$router.push("./moca");
    },
  },
  mounted() {
    
  },
  components: {
    heard,
    foot,
    SignCanvas
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  .content {
    height: calc(100% - 108px);
    box-sizing: border-box;
    padding: 0 60px;
    background: #97bd97;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-top: 45px;
    position: relative;
    .leftImg {
      width: 850px;
      height: 600px;
      // margin-left: 10%;
      
       background-image: url(~@/assets/logo.svg);
       background-size: cover;
       background-position: center;
       background-repeat: no-repeat;
      
      border-radius: 15px;
      box-shadow: 0 10px 20px rgba(0,0,0,0.2);
      transition: all 0.3s ease;
      img {
        // width: 100%;
        // height: 100%;
        width: 442px;
      height: 439px;
      }
    }


    .rightCont {
      display: flex;
      align-items: center;
      flex-direction: column;
      .title {
        font-size: 48px;
        color: #fff;
        span {
          color: #00e9b6;
        }
      }
      .choose {
        color: #d0dcd0;
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 15px;
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        width: 126px;
        height: 40px;
        color: #fff;
        background-color: rgba(86, 129, 86, 1);
        box-shadow: 0 6px 6px 1px rgba(0, 0, 0, 0.5);
        cursor: pointer;
  
      }
    }
    .commwrap {
      box-sizing: border-box;
      padding: 5px;
      width: 50%;
      height: 50%;
      position: absolute;
    }
    .one {
      left: 0;
      top: 0;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
    }
    .two {
      right: 0;
      top: 0;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      align-items: flex-end;
    }
    .three {
      height: 50.1%;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }
    .four {
      height: 50.1%;
      position: absolute;
      right: 0;
      bottom: 0;
      align-items: flex-end;
    }
    zoom: 1;
    position: relative;
    .commcontent {
      // box-shadow: 0px 1px 4px rgba(0,0,0,0.3),0px 0px 10px #ddd inset;
      width: 150px;
      height: 60px;
      background: #ed7d31;
      color: #fff;
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.5s;
      &:hover {
        scale: 1.1;
      }
    }
    // .mmme {
    //   border-radius: 8px ;
    // }
    // .moca {
    //   border-radius: 8px ;
    // }
    // .fer {
    //   border-radius: 8px ;
    // }
    // .frmr {
    //   border-radius: 8px ;
    // }
    .title {
      margin: 10px 0;
      color: black;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
    }
    .examTable {
      border: 1px solid black;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="less">
.dialogBody {
  .el-radio__label {
    display: none;
  }
  .content1 {
    border: 1px solid #000000;
    padding: 25px;
    border-bottom: 0;
    box-sizing: border-box;
  }
  .content2 {
    // display: flex;
    .left {
      padding-left: 40px;
      border: 1px solid #000000;
      box-sizing: border-box;
      position: relative;
      .radio {
        position: absolute;
        width: 30px;
        left: 10px;
        border-right: 1px solid #000000;
        display: flex;
        align-items: center;
        height: 232px;
      }
      .title-b {
        text-align: left;
        padding: 5px;
        border-bottom: 1px solid #000000;
      }
      .canvas {
        height: 200px;
        position: relative;
        .sign-canvas{
          position: absolute;
          left: 1px;
          top: 0;
        }
        .btnList{
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }
    }
    .right {
      padding-left: 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: 1px solid #000000;
      height: 100px;
      border-top: 0;
      position: relative;
      .radio {
        position: absolute;
        width: 30px;
        left: 10px;
        border-right: 1px solid #000000;
        display: flex;
        align-items: center;
        height: 100px;
      }
      .upload {
        margin-right: 4px;
        margin-left: 25px;
      }
    }
    .active {
      border: 1px solid #97bd97 !important;
    }
    // padding-left: 25px;
    // padding-top: 25px;
  }
}
</style>
